export const PARAMS_HEADER_MAPPING = {
  'api-keys': 'API Keys',
  '2fa': 'Two-Factor Authentication',
  webhook: 'Webhook',
};
